import { Box } from "@mui/material";
import { type SxProps, type Theme } from "@mui/material/styles";

import PieceBackfill from "../../components/piece-backfill/piece-backfill";
import { RequireAuth } from "../../hooks/use-auth";

const styles = {
  content: { p: 3 },
} satisfies Record<string, SxProps<Theme>>;

/**
 * Route page for the piece backfill internal tool. Gates access behind
 * `RequireAuth` and renders the tool in a padded content area; the backend
 * additionally requires the INTERNAL_TOOLS write permission on every operation.
 */
const PieceBackfillPage = () => {
  return (
    <RequireAuth>
      <Box sx={styles.content}>
        <PieceBackfill />
      </Box>
    </RequireAuth>
  );
};

export default PieceBackfillPage;
